<template>
  <svg class="xpinner"
       :class="[itemColor, newSpeed, newMode]"
       v-bind:width="size"
       v-bind:height="size"
       alt="Loading Spinner"
       viewBox="0 0 400 400"
       xmlns="http://www.w3.org/2000/svg">
    <circle v-if="hasBackground" class="bk" cx="200" cy="200" r="175" />
    <circle class="fill" cx="200" cy="200" r="175" />
  </svg>
</template>

<script lang="ts">
  import Vue from "vue";
  import {EColor} from "~/enums/eColor";
  import {eColors} from "~/modules/gColors/colors";
  import {Logger} from "~/services/logger";

  /* ------------------------- Readme
  modes: ['single', 'double', 'triplet', 'draw'],
  speeds: ['slow', 'regular', 'fast']
  ---------------------------- */

  export default Vue.extend({
    props: {
      mode: {
        type: String,
        default: 'draw',
      },
      speed: {
        type: String,
        default: 'slow'
      },
      color: {
        type: String as () => EColor,
        default: 'Blue'
      },
      size: {
        type: String,
        default: '16'
      },
      hasBackground: {
        type: Boolean,
        default: true
      }
    },
    data: function () {
      return {
        modes: ['single', 'double', 'triplet', 'draw'],
        speeds: ['slow', 'regular', 'fast'],
        colors: [...eColors, 'White'],
      };
    },
    computed: {
      itemColor: {
        get() {
          if(this.colors.includes(this.color)){
            return EColor[this.color];
          } else if(this.color === "") {
            return "";
          } else {
            Logger.errorOnce('Xpinner', `Color *${this.color}* not available for the spinner.`, 'Try one of these values instead:', this.colors);
            return "color-unavailable";
          }
        },
        set() {},
      },
      newSpeed(): string {
        if(!this.speeds.includes(this.speed)){
          Logger.errorOnce('Xpinner', 'Speed not available for the spinner.', 'Try one of these values instead:', this.speeds);
        }
        return this.speed;
      },
      newMode(): string {
        if(!this.modes.includes(this.mode)){
          Logger.errorOnce('XPinner', 'Mode not available for the spinner.', 'Try one of these values instead:', this.modes);
        }
        return this.mode;
      },
    },
  });
</script>
